import React, { Component, Fragment } from "react";
import {
  Image,
  Container,
  Button,
  Card,
  Item,
  Dimmer,
  Label,
  Header,
  Segment
} from "semantic-ui-react";

import LinkedInBadge from "./LinkedInBadge";
import * as CONSTANTS from "../assets/Constants";
import MALE_DEFAULT_PIC from "../assets/images/male.jpg"
import FEMALE_DEFAULT_PIC from "../assets/images/female.png"

class MemberProfile extends Component {
  state = { modalOpen: false };

  renderProfilePic = (github, gender, imageSize, enableAvatar, driveImage) => {
    let displayPic =
      MALE_DEFAULT_PIC;
    // eslint-disable-next-line eqeqeq
    if (gender == "FEMALE") {
      displayPic = FEMALE_DEFAULT_PIC;
    }
    // eslint-disable-next-line eqeqeq
    if (!github == "") {
      displayPic = "https://avatars.githubusercontent.com/" + github;
    }
    // eslint-disable-next-line eqeqeq
    if (!driveImage == "") {
      displayPic = CONSTANTS.DRIVE_URL + driveImage;
    }
    // console.log(displayPic);
    return (
      <Image  size={imageSize} avatar={enableAvatar} src={displayPic} wrapped/>
    );
  };

  handleOpen = () => this.setState({ modalOpen: true });

  handleClose = () => this.setState({ modalOpen: false });

  renderGithub = github => {
    // eslint-disable-next-line eqeqeq
    if (!github == "") {
      return (
        <Button
          circular
          size="medium"
          href={"https://github.com/" + github}
          target="_blank"
          rel="noopener noreferrer"
          color="grey"
          icon="github"
        />
      );
    }
  };

  renderLinkedInBadge = linkedIn => {
    // eslint-disable-next-line eqeqeq
    if (!linkedIn == "") {
      return (
        // <Grid.Column verticalAlign="middle">
        // {/* <Grid.Row textAlign="center"> */}
        // <Container text>
        <LinkedInBadge linkedInHandle={linkedIn} />
        // </Container>
        // {/* </Grid.Row> */}
        // </Grid.Column>
      );
    }
  };

  renderLinkedIn = linkedIn => {
    // eslint-disable-next-line eqeqeq
    if (!linkedIn == "") {
      return (
        <Button
          circular
          size="medium"
          href={"https://linkedin.com/in/" + linkedIn}
          target="_blank"
          rel="noopener noreferrer"
          color="blue"
          icon="linkedin"
        />
      );
    }
  };

  renderMedium = medium => {
    // eslint-disable-next-line eqeqeq
    if (!medium == "") {
      return (
        <Button
          circular
          size="medium"
          href={"https://medium.com/@" + medium}
          target="_blank"
          rel="noopener noreferrer"
          color="black"
          icon="medium m"
        />
      );
    }
  };

  renderMail = email => {
    // eslint-disable-next-line eqeqeq
    if (!email == "") {
      return (
        <Button
          circular
          size="medium"
          href={"mailto:" + email}
          target="_blank"
          rel="noopener noreferrer"
          color="youtube"
          icon="mail"
        />
      );
    }
  };

  renderDesignation = designation => {
    // eslint-disable-next-line eqeqeq
    if (!designation == "") {
      return (
        <div>
          <Item.Description style={{ marginTop: "1em", color: "gray" }}>
            Designation:
          </Item.Description>
          <Item.Description>{designation}</Item.Description>
        </div>
      );
    }
  };

  renderMilestones = milestones => {
    // eslint-disable-next-line eqeqeq
    if (!milestones == "") {
      return (
        <div>
          <Item.Description style={{ marginTop: "1em", color: "gray" }}>
            I worked hard to achieve these milestones:
          </Item.Description>
          <Item.Description>{milestones}</Item.Description>
        </div>
      );
    }
  };

  renderVision = vision => {
    // eslint-disable-next-line eqeqeq
    if (!vision == "") {
      return (
        <div>
          <Item.Description style={{ marginTop: "1em", color: "gray" }}>
            My Vision for RCS:
          </Item.Description>
          <Item.Description>{vision}</Item.Description>
        </div>
      );
    }
  };

  renderAreasOfExpertise = areasOfExpertise => {
    // eslint-disable-next-line eqeqeq
    if (!areasOfExpertise == "") {
      const labelsList = [];
      areasOfExpertise.split(",").forEach(function(each) {
        labelsList.push(<Label key={each}>{each}</Label>);
      });
      return (
        <div>
          <Item.Description style={{ marginTop: "1em", color: "gray" }}>
            Not to brag, but here are some of my skills:
          </Item.Description>
          <div>{labelsList}</div>
        </div>
      );
    }
  };

  renderCardOrLabel = (type, member) => {
    if (type === "CARD") {
      return (
        <Card onClick={this.handleOpen} key={member.id}>
          {this.renderProfilePic(
            member.details.github,
            member.gender,
            "medium",
            false,
            member.details.drive_image
          )}
          <Card.Content>
            <Card.Header>{member.name.toUpperCase()}</Card.Header>
            {/* <Card.Meta>
              <span>{member.reg_no}</span>
            </Card.Meta> */}
            <Card.Meta>
              <span>{member.branch}</span>
            </Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <div>
              {this.renderLinkedIn(member.details.linkedin)}
              {this.renderGithub(member.details.github)}
              {this.renderMedium(member.details.medium)}
              {/* {this.renderMail(member.details.email)} */}
            </div>
          </Card.Content>
        </Card>
      );
    } else {
      return (
        <Label onClick={this.handleOpen} as="a" key={member.id} size={this.props.size} basic={true} >
          {member.name.toUpperCase()}
        </Label>
      );
    }
  };

  render() {
    let member = this.props.data;
    let type = this.props.type;
    return (
      <Fragment>
        {/* <div> */}
        {this.renderCardOrLabel(type, member)}
        <Dimmer
          active={this.state.modalOpen}
          onClickOutside={this.handleClose}
          page
        >
          {/* <Grid columns="equal" stackable centered>
            <Grid.Row>
              <Header inverted textAlign="center">
                {member.name.toUpperCase()}
              </Header>
            </Grid.Row>
            <Grid.Row>
              {this.renderLinkedIn(member.details.linkedin)}
              <Grid.Column textAlign="center">
                <Grid.Row>
                  <Segment>
                    <Header inverted>ajgdosaij</Header>
                  </Segment>
                </Grid.Row>
              </Grid.Column>
            </Grid.Row>
          </Grid> */}
          {/* <Container text> */}
          <Segment style={{ backgroundColor: "#111111" }}>
            <Item.Group>
              <Item>
                <Item.Content verticalAlign="middle">
                  {this.renderLinkedInBadge(member.details.linkedin)}
                </Item.Content>
                <Item.Content>
                  <Container text>
                    <Item.Header as="h3" style={{ marginTop: "2em" }}>
                      {this.renderProfilePic(
                        member.details.github,
                        member.gender,
                        "mini",
                        true,
                        member.details.drive_image
                      )}{" "}
                      {"  " + member.name.toUpperCase()}
                    </Item.Header>

                    <Item.Meta>
                      <span style={{ color: "white" }}>{member.reg_no} {" (Year of Pass Out:" + member.batch + ")"}</span>
                      {/* <span>Category</span> */}
                    </Item.Meta>
                    {this.renderDesignation(member.details.current_designation)}
                    {this.renderMilestones(member.details.milestones)}
                    {this.renderVision(member.details.vision)}
                    {this.renderAreasOfExpertise(
                      member.details.areas_of_expertise
                    )}
                    <Item.Description
                      style={{ marginTop: "1em", color: "gray" }}
                    >
                      Connect with me on:
                    </Item.Description>
                    <Item.Extra>
                      <div>
                        {this.renderLinkedIn(member.details.linkedin)}
                        {this.renderGithub(member.details.github)}
                        {this.renderMedium(member.details.medium)}
                        {this.renderMail(member.details.email)}
                      </div>
                      <div>
                        <Header
                          as="h6"
                          style={{
                            marginTop: "1em",
                            color: "gray",
                            fontSize: "0.7em"
                          }}
                          size="tiny"
                        >
                          Last Updated on:{" "}
                          {new Date(
                            new Date(member.details.modified_at).toUTCString()
                          ).toLocaleString()}
                        </Header>
                      </div>
                    </Item.Extra>
                  </Container>
                </Item.Content>
              </Item>
            </Item.Group>
          </Segment>
          {/* </Container> */}
        </Dimmer>
      </Fragment>
      // </div>
    );
  }
}

export default MemberProfile;
